export function parseApiBaseUrl(value: unknown): string {
  if (value === undefined || value === null || value === '') {
    return '';
  }

  if (
    typeof value !== 'string' ||
    !URL.canParse(value) ||
    new URL(value).protocol !== 'https:'
  ) {
    throw new Error('The runtime API base URL must be a valid HTTPS URL.');
  }

  return value;
}
